import format from 'quasar/src/utils/format.js';


export function makeImageBlob(url: string, name = '') {
  return fetch(url)
    .then(value => value.blob())
    .then((result) => {
      if (!name) {
        name = url.substr(url.lastIndexOf('/'))
      }
      const file = new File([result], name)
      const img = new Image()
      img.src = URL.createObjectURL(result)
      // @ts-ignore
      file.__img = img
      // @ts-ignore
      file.__sizeLabel = format.humanStorageSize(file.size)

      return file
    })
}
